import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  ListSubheader,
  TextField,
  IconButton,
  Checkbox,
  ListItemText,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useAuth } from "../../../../AuthProvider";
import CircularProgress from "@mui/material/CircularProgress";
import { GlobalStyles } from "@mui/system";
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2'; // Import Swal

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const SubjectCategoryMarksType = () => {
        
  const navigate = useNavigate();
  const { userId, oId, pId, role ,board} = useAuth(); // Access userId from AuthContext
  const [sscClassOptions, setSscClassOptions] = useState([]);
  const [sscSelectedClass, setSscSelectedClass] = useState("");
  const [sscExamTypeOptions, setSscExamTypeOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedExamType, setSelectedExamType] = useState("");
  const [examTypeOptions, setExamTypeOptions] = useState([]);
  const [classValue, setClassValue] = useState("");
  const [examType, setExamType] = useState([]);
  // const [marksType, setMarksType] = useState([]);
  // const [marksOptions, setMarksOptions] = useState(["Project Work", "Internals", "Slip Test"]);
  // const [newMarksType, setNewMarksType] = useState("");
  const [marksOptions, setMarksOptions] = useState([
  { category: "Example   Project Work", marks: "50" },
  // { category: "Internals", marks: "30" },
  // { category: "Slip Test", marks: "20" },
]);
const [marksType, setMarksType] = useState([]); // selected categories with marks
const [newMarksType, setNewMarksType] = useState({ category: "", marks: "" });



  const [tableData, setTableData] = useState([]);
  const [editRowId, setEditRowId] = useState(null);
  const [editData, setEditData] = useState({});

  // state
const [loading, setLoading] = useState(false);
const [tableLoading, setTableLoading] = useState(false); // To handle button state

  // Fetch class list
  const fetchClassRegistrationData = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/dynamic-classReg/class-registrations/${oId}/${pId}`);
      const data = await response.json();
      if (response.ok && Array.isArray(data)) {
        const classes = [...new Set(data.map((item) => item.classRegistration))];
        setSscClassOptions(classes);
        setSelectedClass(classes[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch exam types
useEffect(() => {
  fetchExamTypeOptions();
}, [classValue,selectedClass]);

// Fetch exam types
const fetchExamTypeOptions = async () => {
  try {
    const selected = classValue || selectedClass;
    if (!selected) return;

    let url = `${baseUrl}/api/dynamic-classReg/getAllExamsType/by-class/${pId}?classRegistration=${selected}`;
    // if (board === "INTERMEDIATE") {
    //   url += `&course=${selectedCourseType}`;
    // }

    const response = await fetch(url);
    const data = await response.json();

    if (response.ok && Array.isArray(data) && data.length > 0) {
      // Handle when API returns ["FA-1,FA-2,..."]
      let examsArray = [];
      if (typeof data[0] === "string") {
        examsArray = data[0].split(",").map((name) => ({
          value: name.trim().toUpperCase().replace(/\s+/g, "_"),
          label: name.trim(),
        }));
      } else {
        // fallback if API sends array of objects already
        examsArray = data.map((name) => ({
          value: String(name).trim().toUpperCase().replace(/\s+/g, "_"),
          label: String(name).trim(),
        }));
      }
      
      setExamTypeOptions(examsArray);
      setSscExamTypeOptions(examsArray);
       // ✅ Select first record by default
      if (examsArray.length > 0) {
        setSelectedExamType(examsArray[0].value);
      }
    } else {
      setExamTypeOptions([]);
      setSscExamTypeOptions([]);
      setSelectedExamType(""); // reset if nothing found
    }
  } catch (error) {
    console.error("Failed to fetch exam types:", error);
    setExamTypeOptions([]);
    setSscExamTypeOptions([]);
  }
};


  // Fetch table data
  const fetchTableData = async () => {
    if(!selectedClass || !selectedExamType) return;

    setTableLoading(true)
    try {
      const res = await fetch(`${baseUrl}/api/subjectCategory/getAllSubjectCategories/${pId}?romanNumberClass=${selectedClass}&examType=${selectedExamType}`);
      const data = await res.json();
      if (res.ok) setTableData(data);
    } catch (error) {
      console.error(error);
    }finally {
    setTableLoading(false);
  }
  };
    useEffect(() => {
    fetchTableData();
  }, [selectedClass,selectedExamType]);


//   const handleAddMarksType = () => {
//   if (!newMarksType.category.trim() || !newMarksType.marks.trim()) return;

//   setMarksOptions((prev) => [...prev, newMarksType]);
//   setMarksType((prev) => [...prev, newMarksType]);
//   setNewMarksType({ category: "", marks: "" });
// };
const handleAddMarksType = () => {
  if (!newMarksType.category.trim() || !newMarksType.marks.trim()) return;

  setMarksOptions((prev) => [...prev, newMarksType]);
  setMarksType((prev) => [...prev, newMarksType]);
  setNewMarksType({ category: "", marks: "" });
};


const handleRemoveMarksType = (index) => {
  setMarksOptions((prev) => prev.filter((_, i) => i !== index));
  setMarksType((prev) => prev.filter((_, i) => i !== index));
};


// const handleSubmit = async () => {
//   if (!classValue){
//      toast.error("Please select Class");
//     return;
//   }else if(!examType.length === 0){
//      toast.error("Please select atleast one Exam Type");
//     return;
//   }else if(marksType.length === 0){
//     toast.error("Please select atleast One Category");
//     return;
//   }
//   setLoading(true);
//   try {
//     const queryParams = new URLSearchParams({
//       romanNumberClass: classValue,
//       examTypes: examType.join(","),
//       // subjectsCategory: marksType.join(",")
//       subjectsCategory: JSON.stringify(marksType), 
//     });

//     const res = await fetch(
//       `${baseUrl}/api/subjectCategory/create/${oId}/${pId}?${queryParams.toString()}`,
//       {
//         method: "POST"
//       }
//     );

//     // Parse the response text (or JSON) for both success and error cases
//     const contentType = res.headers.get("content-type");
//     let responseData;
//     if (contentType && contentType.includes("application/json")) {
//       responseData = await res.json();
//     } else {
//       responseData = await res.text();
//     }

//     if (!res.ok) {
//       // Show actual message from backend instead of generic
//       throw new Error(
//         typeof responseData === "string"
//           ? responseData
//           : responseData?.message || "Failed to submit"
//       );
//     }

//     toast.success(
//       responseData?.message || "Subject Category Type submitted successfully!", { autoClose: 1000 }
//     );
//     fetchTableData();
//     setClassValue("");
//     setExamType([]);
//     setMarksType([]);
//   } catch (error) {
//     toast.error(error.message);
//   } finally {
//     setLoading(false);
//   }
// };


const handleSubmit = async () => {
  if (!classValue) {
    toast.error("Please select Class");
    return;
  } else if (examType.length === 0) {
    toast.error("Please select atleast one Exam Type");
    return;
  } else if (marksType.length === 0) {
    toast.error("Please select atleast One Category");
    return;
  }

  setLoading(true);
  try {
    // Build request payload
    const payload = [];

    examType.forEach((exam) => {
      marksType.forEach((mark) => {
        payload.push({
          romanNumberClass: classValue,
          examType: exam,
          subjectsCategory: mark.category,
          totalMarks: Number(mark.marks), // ensure number
        });
      });
    });

    const res = await fetch(
      `${baseUrl}/api/subjectCategory/create-multiple/${oId}/${pId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    // Parse response
    const contentType = res.headers.get("content-type");
    let responseData;
    if (contentType && contentType.includes("application/json")) {
      responseData = await res.json();
    } else {
      responseData = await res.text();
    }

    if (!res.ok) {
      throw new Error(
        typeof responseData === "string"
          ? responseData
          : responseData?.message || "Failed to submit"
      );
    }

    toast.success(
      responseData?.message || "Subject Category Type submitted successfully!",
      { autoClose: 1000 }
    );

    fetchTableData();
    setClassValue("");
    setExamType([]);
    setMarksType([]);
  } catch (error) {
    toast.error(error.message);
  } finally {
    setLoading(false);
  }
};


  const handleEdit = (row) => {
    setEditRowId(row.sId);
    setEditData(row);
  };

  const handleSave = async () => {
  try {
    // Remove null/undefined or unwanted fields
    const filteredData = Object.fromEntries(
      Object.entries(editData).filter(
        ([key, value]) => value !== null && value !== undefined && key !== "obtainedMarks"
      )
    );

    // Convert to query params
    const queryParams = new URLSearchParams(filteredData);

    const res = await fetch(
      `${baseUrl}/api/subjectCategory/updateSubjectCategory/${editRowId}?${queryParams.toString()}`,
      { method: "PATCH" }
    );

    if (!res.ok) {
      const errorText = await res.text(); // capture backend error message
      throw new Error(errorText || "Failed to update");
    }

    toast.success("Updated successfully!", { autoClose: 1000 });
    setEditRowId(null);
    fetchTableData();
  } catch (error) {
    toast.error(error.message);
  }
};


  useEffect(() => {
    fetchClassRegistrationData();
    fetchTableData();
  }, []);




    // Handle delete with swal confirmation
  const handleDelete = async (row) => {
    // Show confirmation dialog with swal
    Swal.fire({
      title: `Are you sure you want to delete?`,
        html: `<b style="color:red;">${row.romanNumberClass}, ${row.examType}</b> Subject Category <b style="color:red;">${row.subjectsCategory}</b>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${baseUrl}/api/subjectCategory/delete/${row.sId}`, {
            method: 'DELETE',
          });
          if (response.ok) {
            toast.success(`${row.romanNumberClass}, ${row.examType} Subject Category Type ${row.subjectsCategory} has been deleted successfully!`, {
              position:"top-right",
              autoClose: 1000,
            });
            fetchTableData();
          } else {
            console.error("Error deleting Subject Category Type", response.statusText);
            // Swal.fire("Error!", "An error occurred while deleting.", "error");
            toast.error("Error deleting Subject Category Type", {
              position: "top-right",
              autoClose: 1000,
            });
          }
        } catch (error) {
          console.error("Error deleting Subject Category Type:", error);
          // Swal.fire("Error!", "An error occurred while deleting.", "error");
          toast.error("There was an issue while deleting", {
            position: "top-right",
            autoClose: 1000,
          });
        }
      }
    });
  };

  return (
    <Box p={3}
     sx={{
      padding: "7px 10px 10px 10px",
      borderRadius: 3,
      margin: "5% 1% 1% 1%",
      bgcolor: "#fff",
    }}
    
    >
          {/* Left side: Back icon and title */}
          <Box display="flex" alignItems="center" sx={{marginBottom:'10px'}}>
            <IconButton
              onClick={() => navigate(-1)}
              sx={{ color: "#2e2a54" }}
            >
              <KeyboardBackspaceIcon fontSize="medium" />
            </IconButton>
            <Typography variant="h4" sx={{ fontWeight: "bold" }}>
              Add Subject Category
            </Typography>
          </Box>

      {/* First Card */}
      <Card sx={{ mb: 3, boxShadow: 4 }}>
        <CardHeader title="Add Subject Category Type" sx={{ bgcolor: "#d9d9d9", color: "black",fontWeight:'bold' }} />
        <CardContent>
          <Box display="flex" gap={2} alignItems="center">
            {/* Class */}
            <FormControl sx={{ minWidth: 200,}}>
              <InputLabel>Select Class</InputLabel>
              <Select 
              label="Select Class" 
              value={classValue} 
              onChange={(e) => setClassValue(e.target.value)}>
                {sscClassOptions.map((cls) => (
                  <MenuItem key={cls} value={cls}>
                    {cls}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Exam Type */}
          
            <FormControl sx={{ minWidth: 250,}}>
  <InputLabel>Exam Type</InputLabel>
  <Select
    label="Exam Type"
    multiple
    value={examType}
    onChange={(e) => setExamType(e.target.value)}
    renderValue={(selected) =>
      examTypeOptions
        .filter((option) => selected.includes(option.value))
        .map((option) => option.label)
        .join(", ")
    }
  >
    {examTypeOptions.map((type) => (
      <MenuItem key={type.value} value={type.value}>
        <Checkbox checked={examType.indexOf(type.value) > -1} />
        <ListItemText primary={type.label} />
      </MenuItem>
    ))}
  </Select>
</FormControl>

            {/* Marks Type */}
           <FormControl fullWidth>
  <InputLabel>Add Category Type & Marks</InputLabel>

  <Select
  multiple
  value={marksType.map((item) => item.category)} // store only category names
  onChange={(e) => {
    const selected = e.target.value;

    // Map selected categories back to their full objects from marksOptions
    const updated = selected.map(
      (cat) => marksOptions.find((item) => item.category === cat) || { category: cat, marks: "" }
    );

    setMarksType(updated);
  }}
 renderValue={(selected) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: "4px",
      whiteSpace: "normal",   // 👈 allows wrapping
    }}
  >
    {selected.map((cat) => {
      const marks = marksType.find((item) => item.category === cat)?.marks || "";
      return (
        <Typography
          key={cat}
          variant="body2"
          noWrap
          sx={{ maxWidth: "120px", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {cat} ({marks})
        </Typography>
      );
    })}
  </Box>
)}

  input={<OutlinedInput label="Add Category Type & Marks" />}>

   <ListSubheader
  // prevent Select from hijacking keyboard events
  onKeyDown={(e) => e.stopPropagation()}
  onMouseDown={(e) => e.stopPropagation()}
  onClick={(e) => e.stopPropagation()}
>
  <Box display="flex" gap={1}>
    {/* Category Type */}
    <TextField
      placeholder="Add Category Type"
      size="small"
      value={newMarksType.category}
      onChange={(e) => {
        const newValue = e.target.value.toUpperCase();
        setNewMarksType((prev) => ({
          ...prev,
          category: newValue,
        }));
      }}
      fullWidth
    />

    {/* Marks */}
    <TextField
      placeholder="Enter Marks"
      size="small"
      type="text"
      inputProps={{ min: 0 }}
      value={newMarksType.marks}
      onChange={(e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
          setNewMarksType((prev) => ({ ...prev, marks: value }));
        }
      }}
      fullWidth
    />

    {/* Add Button */}
    <IconButton
      onClick={handleAddMarksType}
      disabled={
        !newMarksType.category.trim() || !newMarksType.marks.trim()
      }
    >
      <AddIcon />
    </IconButton>
  </Box>
</ListSubheader>


   {marksOptions.map((item, index) => (
      <MenuItem key={index} value={item.category}>
        <Checkbox
          checked={marksType.some((m) => m.category === item.category)}
        />
        <ListItemText primary={`${item.category} (${item.marks})`} />
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveMarksType(index);
          }}
        >
          <CloseIcon />
        </IconButton>
      </MenuItem>
    ))} 
          
  </Select>
</FormControl>


          <Button
  variant="contained"
  sx={{
    bgcolor: "#3C3972",
    height: 48, // Increased height
    px: 4,
    fontWeight: "bold",
    "&:hover": { backgroundColor: "#3C3972" }
  }}
  onClick={handleSubmit}
  disabled={loading}
>
  {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Submit"}
</Button>

          </Box>
        </CardContent>
      </Card>

      {/* Second Card */}
      <Card sx={{ boxShadow: 4 }}>
        <CardHeader title="Subject Category Type List" sx={{ bgcolor: "#d9d9d9", color: "black",fontWeight:'bold'}} />
        <FormControl size="small" sx={{ minWidth: 120,margin:'10px 10px 5px 20px'}}>
                  <InputLabel id="class-select-label">Select Class</InputLabel>
                  <Select
                    labelId="class-select-label"
                    value={selectedClass}
                   
            
                    onChange={(e) => {
                      const selected = e.target.value;
                      setSelectedClass(selected);
                    }}
                    
                    label="Select Class"
                    sx={{ height: 35 }}
                  >
                    {sscClassOptions.map((cls) => (
                      <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl size="small" sx={{ minWidth: 120, margin: '10px 10px 5px 20px' }}>
  <InputLabel id="Exam-select-label">Select ExamType</InputLabel>
  <Select
    labelId="Exam-select-label"
    value={selectedExamType}
    onChange={(e) => {
      setSelectedExamType(e.target.value);
    }}
    label="Select ExamType"
    sx={{ height: 35 }}
  >
    {sscExamTypeOptions.map((cls) => (
      <MenuItem key={cls.value} value={cls.value}>
        {cls.label}
      </MenuItem>
    ))}
  </Select>
</FormControl>

        <CardContent>
          <Paper>

            

              <GlobalStyles
                        styles={{
                          ".custom-sidebar-scrollbar": {
                            scrollbarWidth: "thin", // For Firefox
                            scrollbarColor: "grey #e0e0e0",
                          },
                          ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                            width: "6px", // For WebKit-based browsers
                          },
                          ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                            background: "#f1f1f1", // Track color
                          },
                          ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                            backgroundColor: "grey", // Thumb color
                            borderRadius: "10px",
                          },
                          ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "#555",
                          },
                        }}
                      />
             <TableContainer
                        component={Paper}
                        sx={{
                          borderRadius: 2,
                          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                          maxHeight: "400px",
                          overflow: "auto",
                        }}
                        className="custom-sidebar-scrollbar"
                      >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>S.No</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Class</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Exam Type</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Subject Category Type</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Total Marks</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Actions</TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center", backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:"13px"}}>Delete</TableCell>
                </TableRow>
              </TableHead>
                 {tableLoading ? (
                              <TableBody>
                                <TableRow>
              
                                  <TableCell
                                    colSpan={6}
                                    style={{ textAlign: "center", padding: "20px" }}
                                  >
                                    <Box
                                      display="flex"
                                      flexDirection="column"
                                      alignItems="center"
                                    >
                                      <CircularProgress />
                                      <Typography variant="body2" sx={{ mt: 1 }}>
                                        Loading Data...
                                      </Typography>
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            ) : tableData.length === 0 ? (
                              <TableBody>
                                <TableRow>
                                  <TableCell colSpan={6} sx={{ textAlign: "center" }}>
                                    No data found
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            ) : (
              <TableBody>
                {tableData.map((row,index) => (
                  <TableRow key={index} style={{ backgroundColor: "white", transition: "background-color 0.3s" }} onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f1f1f1")} onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "white")}>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>{index + 1}</TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
                      
                      {row.romanNumberClass}
                    </TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
                   {/* {editRowId === row.sId ? (
                        <TextField
                          value={editData.examType}
                          onChange={(e) => setEditData({ ...editData, examType: e.target.value })}
                        />
                      ) : (
                        row.examType
                      )} */}
                       {row.examType}
                    </TableCell>
                    <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
                      {editRowId === row.sId ? (
                        <TextField
                          value={editData.subjectsCategory}
                          placeholder="Enter Category"
                          onChange={(e) => setEditData({ ...editData, subjectsCategory: e.target.value })}
                        />
                      ) : (
                        row.subjectsCategory
                      )}
                    </TableCell>
                   <TableCell
  sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}
>
  {editRowId === row.sId ? (
    <TextField
      type="text"
      value={editData.totalMarks}
      placeholder="Enter Marks"
      inputProps={{ min: 0 }} // ✅ disallow negatives
      onChange={(e) => {
        const value = e.target.value;
        // ✅ Allow only numbers (digits), block minus and letters
        if (/^\d*$/.test(value)) {
          setEditData({ ...editData, totalMarks: value });
        }
      }}
    />
  ) : (
    row.totalMarks
  )}
</TableCell>

                 
<TableCell
  sx={{
    borderRight: "1px solid #ddd",
    padding: "4px",
    textAlign: "center",
  }}
>
  {editRowId === row.sId ? (
    <>
      {/* Save Button */}
      <Button
        variant="contained"
        color="success"
        size="small"
        onClick={handleSave}
        sx={{ mr: 1 }}
      >
        Save
      </Button>

      {/* Cancel Button */}
      <Button
        variant="outlined"
        // color="error"
        size="small"
        onClick={() => setEditRowId(null)}
      >
        Cancel
      </Button>
    </>
  ) : (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={() => handleEdit(row)}
    >
      Edit
    </Button>
  )}
</TableCell>


  <TableCell
                          sx={{
                            borderRight: "1px solid #ddd",
                            textAlign: "center",
                            padding: "2px",
                            maxWidth: "50px",
                            minWidth: "50px",
                          }}
                        >
                          <IconButton
                            aria-label="delete"
                            onClick={() => handleDelete(row)}
                            sx={{ color: "red", padding: "2px" }}
                          >
                            <DeleteIcon fontSize="small" /> {/* Reduce icon size */}
                          </IconButton>
                        </TableCell>


                  </TableRow>
                ))}
              </TableBody>
              )}
            </Table>
            </TableContainer>
          </Paper>
        </CardContent>
      </Card>

      <ToastContainer position="top-right" autoClose={2000} />
    </Box>
  );
};

export default SubjectCategoryMarksType;
